<template>
  <div class="contact">
    <div class="container">
      <div class="inside">
        <div class="box">
          <div class="elements clearfix">
            <div class="element">
              <div class="info">
                <div class="top-text" data-aos="fade-up">
                  {{$t('contact.stayInContact')}}
                </div>
                <div class="text" data-aos="fade-up" data-aos-delay="100">
                  Bioseco S.A.
                </div>
                <div class="adress" data-aos="fade-up" data-aos-delay="150">
                  <p>{{$t('contact.street')}}<br/> 80-298 Gdańsk<br/> {{$t('contact.pl')}}</p>
                </div>
                <div class="phone" data-aos="fade-up" data-aos-delay="200">
                  <p>+48 603 422 633</p>
                </div>
                <div class="mail" data-aos="fade-up" data-aos-delay="250">
                  <p>offers@bioseco.com</p>
                </div>
                <div class="bottom" data-aos="fade-up" data-aos-delay="300">
                  NIP 586-22-82-513<br/> NIP EU PL5862282513<br/> REGON 221871650<br/>KRS 0000906735<br/>

                </div>
                <div class="btn-hover">
                  <a @click="showModal()" class="btn orange" data-aos="fade-up" data-aos-delay="350">{{$t('contact.haveQuestions')}}</a>
                </div>
                <!--
                                                <div class="btn-hover" data-aos="fade-up" dat-aos-delay="400">
                                                    <router-link to="/projects" class="btn orange">{{$t('contact.project')}}</router-link>
                                                </div>
                -->
              </div>
            </div>
            <div class="element">
              <div class="map" data-aos="flip-left" data-aos-delay="250">
                <div id="map"></div>
              </div>
            </div>
          </div>
          <router-link class="more-about-us" active-class="active" to="/about">
            <span>{{$t('component.moreAboutUs')}}</span></router-link>
        </div>
      </div>
    </div>
    <div class="right-hexagons">
      <div class="bg-hexagon"></div>
      <div class="bg-hexagon"></div>
      <div class="bg-hexagon"></div>
      <div class="bg-hexagon"></div>
    </div>
  </div>
</template>

<script>
  import store from '../store/store';

  export default {
    name: 'contact',
    data() {
      return {}
    },
    mounted: function () {
      var uluru = {
        lat: 54.371663,
        lng: 18.505612
      };
      var map = new google.maps.Map(document.getElementById('map'), {
        zoom: 16,
        center: uluru
      });
      var marker = new google.maps.Marker({
        position: uluru,
        map: map,
        icon: {
          url: "./static/img/contact/marker.svg",
        }
      });
    },
    methods: {
      menuToggle: () => {
        store.commit('TOGGLE_MENU');
      },
      showModal: function () {
        store.commit('SET_MODAL', {visible: true, questionName: ''});
      }
    },
    computed: {
      lang: () => {
        return store.state.lang;
      }
    }
  }
</script>

<style>
  #map {
    width: 100%;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// Contact.vue?c9d3a0d4